import app from '@/app';
import templateUrl from './plan-detail.html';
import angular from 'angular';

/* @ngInject */
function Controller(
	$controller,
	Plan,
	ConstantSet,
	BudgetLimit,
	GrowthRate,
	Principal,
	Project,
	$http,
	$translate,
	AlertService,
	$state,
	$timeout,
	$stateParams,
	$rootScope
) {
	var $ctrl = this;

	$ctrl.currentAccount = null;

	$ctrl.allRoadtype = ['ROAD', 'STRETCH', 'RIVER'];

	$ctrl.allRateType = ['FIXED', 'VARIABLE'];

	$ctrl.projectType = 'SELECT';

	$ctrl.updating = false;
	$ctrl.isSaving = false;
	$ctrl.isProcessing = false;

	$ctrl.indexItem = null;

	//var projectDefault = { id: null, name: null, status: 'SELECT' };

	$ctrl.onProjectChange = () => {
		switch ($ctrl.projectType) {
			case 'NEW':
				$ctrl.entity.project.name = null;
				$ctrl.entity.project.id = null;
				break;
			case 'SELECT':
				$ctrl.entity.project.name = null;
				$ctrl.entity.project.id = null;
				break;
			case 'OLD':
				$ctrl.entity.project = null;
				break;
			default:
		}
	};

	$ctrl.plans = []; // Plan list

	$ctrl.newPlan = {}; // new object plan

	$ctrl.addNewPlan = function() {
		var duplicateName = $ctrl.plans.some(function(plan) {
			return plan.name === $ctrl.entity.name;
		});

		var duplicateId = $ctrl.plans.some(function(plan) {
			return plan.id === $ctrl.entity.id;
		});

		var duplicateNameProject = $ctrl.plans.some(function(plan) {
			if(plan.project && plan.project.name && plan.project.status == 'NEW'){
				return plan.project.name === $ctrl.entity.project.name;
			}
			return false;
		});

		if (duplicateName) {
			$ctrl.errorMessage = $translate.instant('message.duplicateNamePlanToList');
		}else if(duplicateNameProject){
			$ctrl.errorMessage = $translate.instant('message.duplicateNameProjectToList');
		}
		else {
			$ctrl.newPlan = angular.copy($ctrl.entity);
			$ctrl.newPlan.plantype = 'DEFAULT';
			$ctrl.newPlan.id = !$ctrl.newPlan.id || duplicateId? null : $ctrl.newPlan.id;
			$ctrl.plans.push($ctrl.newPlan);
			$ctrl.errorMessage = null;
		}
	};

	$ctrl.removeItem = index => {
		$ctrl.plans.splice(index, 1);
	};

	$ctrl.updateItem = index => {
		$ctrl.entity = angular.copy($ctrl.plans[index]);
		$ctrl.indexItem = index;
		$ctrl.updating = true;

    /*
		if($ctrl.entity.project == null){
			$ctrl.entity.project = projectDefault;
		}
    */
	};

	$ctrl.clear = () => {
		$ctrl.entity = { project: { id: null, name: null, status: 'SELECT' } };
	};

	$ctrl.progress = 0;

	$ctrl.progress = '0';
	$ctrl.isProcessing = false;
	$ctrl.count = 0;

	$ctrl.saveAllPlans = function() {
		if ($ctrl.isSaving || $ctrl.isProcessing) return;
		$ctrl.isSaving = true;
		$ctrl.isProcessing = true;
		$ctrl.progress = 0;
		$ctrl.count = 0;
		var totalSize = $ctrl.plans.length;
		var promises = $ctrl.plans.map(function(plan) {
			if (plan.id === null) {
				return $http.post('/api/plans', plan).then(function(response) {
					$ctrl.count = $ctrl.count + 1;
					$ctrl.progress = ($ctrl.count / totalSize) * 100;
				});
			} else {
				return $http.put('/api/plans/' + plan.id, plan).then(function(response) {
					$ctrl.count = $ctrl.count + 1;
					$ctrl.progress = ($ctrl.count / totalSize) * 100;
				});
			}
		});

		Promise.all(promises)
			.then(function() {
				AlertService.success('entity.updated.plans', {
					type: 'Plan',
					name: ''
				});
				$rootScope.$broadcast('processStatusChanged');
				$state.go('^', {}, { reload: true });
			})
			.catch(function(error) {
				$ctrl.isProcessing = false;
				$ctrl.isSaving = false;
				console.error('Erro ao salvar todos os planos:', error);
			});
	};

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractEntityDetailController', { $ctrl, resource: Plan, type: 'plan' });

	// Override save to use 'entity.update.message' (async Plan module)
	$ctrl.save = () => {
		if (!$ctrl.readonly && !$ctrl.isSaving && !$ctrl.isProcessing) {
			$ctrl.isSaving = true;
			// Immediate feedback while the request is in flight. The request only
			// ENQUEUES the plan (lightweight); the heavy computation runs in the
			// background queue. Showing the overlay keeps the screen from looking
			// frozen, especially when other large plans are processing.
			$rootScope.isLoadingResults = true;
			const onSuccess = () => {
				// Clear before navigating; the UI-Router transition keeps the overlay
				// up (isTransitioning) until the destination screen has loaded.
				$rootScope.isLoadingResults = false;
				AlertService.success('entity.update.message', {
					type: $ctrl.type,
					name: $ctrl.entity.name
				});
				$rootScope.$broadcast('processStatusChanged');
				$state.go('^', {}, { reload: true });
			};
			const onError = error => {
				$ctrl.isSaving = false;
				$rootScope.isLoadingResults = false;
			};
			if ($ctrl.entity.id) {
				Plan.update($ctrl.entity, onSuccess, onError);
			} else {
				Plan.create($ctrl.entity, onSuccess, onError);
			}
		}
	};

	this.$onInit = function() {
		$http.get('api/projects/group', { params: { onlyUsed: false } }).then(function(response) {
			$ctrl.allProjects = response;
		});

    /*
		if ($ctrl.entity.project == null) {
			$ctrl.entity.project = projectDefault;
		}
    */

		$http.get('api/budgetlimits?query=null').then(function(response) {
			$ctrl.allBudgetLimit = response;
		});

		if ($ctrl.parent.plans.length > 0) {
			$http
				.get('/api/plans/plansId', {
					params: {
						plansId: $ctrl.parent.plans
					}
				})
				.then(function(response) {
					$ctrl.plans = response.data;
				});
		}

	};

	$ctrl.reloadPreviousState = function() {
		$ctrl.parent.plans = [];
		$state.go('^', {}, { reload: true });
	};

	$ctrl.planSave = () => {
		$ctrl.entity.plantype = 'DEFAULT';
		$ctrl.save();
	};

	$ctrl.saveItem = () => {
		$ctrl.updating = false;
		$ctrl.plans[$ctrl.indexItem] = angular.copy($ctrl.entity);
		$ctrl.indexItem = null;
	};

	$ctrl.onRoadSelected = road => {
		$ctrl.entity.road = road;
		$ctrl.entity.headMilestone = road.headMilestone;
		$ctrl.entity.tailMilestone = road.tailMilestone;
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.entity.road = null;
		$ctrl.entity.headMilestone = null;
		$ctrl.entity.tailMilestone = null;
		$ctrl.entity.campaigns = null;
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.entity.road = null;
		$ctrl.entity.headMilestone = null;
		$ctrl.entity.tailMilestone = null;
		$ctrl.entity.campaigns = null;
	};

	$ctrl.queryConstantSets = query => {
		$ctrl.loading = true;
		return ConstantSet.query({ query: query, size: 10, sort: 'name,asc' }, data => {
			$ctrl.allConstantSets = data;
			$ctrl.loading = false;
		}).$promise;
	};

	$ctrl.queryGrowthRates = query => {
		$ctrl.loading = true;
		return GrowthRate.query({ query: query, size: 10, sort: 'name,asc' }, data => {
			$ctrl.allGrowthRates = data;
			$ctrl.loading = false;
		}).$promise;
	};

	$ctrl.queryBudgetLimit = query => {
		if (!query) {
			query = '';
		}
		$ctrl.loading = true;
		return BudgetLimit.query({ query: query, size: 10, sort: 'name,asc' }, data => {
			$ctrl.allBudgetLimit = data;
			$ctrl.loading = false;
		}).$promise;
	};

	$ctrl.byOrganization = value =>
		$ctrl.entity.organization && value.organization.id == $ctrl.entity.organization.id;

	$ctrl.byOwner = value =>
		$ctrl.entity.organization && value.owner.id == $ctrl.entity.organization.id;

	$ctrl.clearUiSelect = function($event, $select) {
		$event.stopPropagation();
		$select.selected = null;
		$select.search = null;
		$ctrl.entity.budgetLimit = null;
	};

}

app.component('planDetail', {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^planSearch'
	},
	bindings: {
		$transition$: '<',
		entity: '<',
		idGrowthRate: '<',
		plansId: '<',
		allDecisionTrees: '<',
	}
});
